import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    'primary-contained': {
      color: STYLE.COLOR.WHITE,
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
      '&:hover': {
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_DARKER} !important`,
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_DISABLED} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'success-contained': {
      color: STYLE.COLOR.WHITE,
      backgroundColor: STYLE.COLOR.SUCCESS,
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_DISABLED} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'error-contained': {
      color: STYLE.COLOR.WHITE,
      backgroundColor: STYLE.COLOR.ERROR,
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_DISABLED} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'warning-contained': {
      color: STYLE.COLOR.WHITE,
      backgroundColor: STYLE.COLOR.WARNING,
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_DISABLED} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'primary-outlined': {
      color: STYLE.COLOR.ACCENT_PRIMARY,
      borderColor: STYLE.COLOR.ACCENT_PRIMARY,
      '& path': {
        stroke: `${STYLE.COLOR.ACCENT_PRIMARY}`,
      },
      '&:hover': {
        '&:not(.Mui-disabled)': {
          transition: 'all 0.2s ease-in',
          backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
          color: STYLE.COLOR.WHITE,
          '& path': {
            transition: 'all 0.2s ease-in',
            stroke: `${STYLE.COLOR.WHITE} !important`,
          },
        },
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
        borderColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        opacity: 0.5,
      },
    },
    'success-outlined': {
      color: STYLE.COLOR.SUCCESS,
      borderColor: STYLE.COLOR.SUCCESS,
      '& path': {
        stroke: `${STYLE.COLOR.SUCCESS}`,
      },
      '&:hover': {
        transition: 'all 0.2s ease-in',
        backgroundColor: `${STYLE.COLOR.SUCCESS} !important`,
        color: STYLE.COLOR.WHITE,
        '& path': {
          stroke: `${STYLE.COLOR.WHITE} !important`,
        },
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.SUCCESS} !important`,
        borderColor: `${STYLE.COLOR.SUCCESS} !important`,
        opacity: 0.5,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
      },
    },
    'error-outlined': {
      color: STYLE.COLOR.ERROR,
      borderColor: STYLE.COLOR.ERROR,
      '& path': {
        stroke: `${STYLE.COLOR.ERROR}`,
      },
      '&:hover': {
        transition: 'all 0.2s ease-in',
        backgroundColor: `${STYLE.COLOR.ERROR} !important`,
        color: STYLE.COLOR.WHITE,
        '& path': {
          stroke: `${STYLE.COLOR.WHITE} !important`,
        },
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.ERROR} !important`,
        borderColor: `${STYLE.COLOR.ERROR} !important`,
        opacity: 0.5,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
      },
    },
    'warning-outlined': {
      color: STYLE.COLOR.WARNING,
      borderColor: STYLE.COLOR.WARNING,
      '& path': {
        stroke: `${STYLE.COLOR.WARNING}`,
      },
      '&:hover': {
        transition: 'all 0.2s ease-in',
        backgroundColor: `${STYLE.COLOR.WARNING} !important`,
        color: STYLE.COLOR.WHITE,
        '& path': {
          stroke: `${STYLE.COLOR.WHITE} !important`,
        },
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.WARNING} !important`,
        borderColor: `${STYLE.COLOR.WARNING} !important`,
        opacity: 0.5,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
      },
    },
    'primary-text': {
      color: STYLE.COLOR.ACCENT_PRIMARY,
      '&:hover': {
        backgroundColor: `transparent !important`,
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'success-text': {
      color: STYLE.COLOR.SUCCESS,
      '&:hover': {
        backgroundColor: `transparent !important`,
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'error-text': {
      color: STYLE.COLOR.ERROR,
      '&:hover': {
        backgroundColor: `transparent !important`,
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    'warning-text': {
      color: STYLE.COLOR.WARNING,
      '&:hover': {
        backgroundColor: `transparent !important`,
      },
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.TEXT3} !important`,
        cursor: 'not-allowed !important',
        pointerEvents: 'all !important',
        '& path': {
          stroke: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
    spinner: {
      height: '20px !important',
      width: '20px !important',
    },
    arrowLeft: {
      transform: 'rotate(180deg)',
    },
  }),
);
